import React from 'react';
import StockItemsPage from 'pages/shared/inventory-stock/stock-items-page';

const PrepInventoryStockItems = () => {
  return <StockItemsPage defaultStoreType='prep-store' />;
};

export default PrepInventoryStockItems;
